// extracted by mini-css-extract-plugin
module.exports = {"appImage":"app-image_appImage__D65wN","appImageWithBorder":"app-image_appImageWithBorder__0quEa"};